__turbopack_context__.v({
  "globe-icon": "dark-header-module-scss-module__rwI4Iq__globe-icon",
  "language-selector": "dark-header-module-scss-module__rwI4Iq__language-selector",
  "logo": "dark-header-module-scss-module__rwI4Iq__logo",
  "menu-icon": "dark-header-module-scss-module__rwI4Iq__menu-icon",
  "nav-content": "dark-header-module-scss-module__rwI4Iq__nav-content",
  "nav-links": "dark-header-module-scss-module__rwI4Iq__nav-links",
  "nav-text": "dark-header-module-scss-module__rwI4Iq__nav-text",
  "navigation": "dark-header-module-scss-module__rwI4Iq__navigation",
});
